import React, { useContext, useState } from 'react'
import PrimaryButton from 'components/generic/PrimaryButton'
import { faCheck, faStar, faInfoCircle } from '@fortawesome/free-solid-svg-icons'
import { StepHeading, ButtonOption, ContentContainer } from 'components/GetStarted/styles'
import { formatStripePrice, getFullPriceForPlan, getSalePriceForPlan } from 'utils/stripeUtils'
import { trackClickEvent } from 'utils/Analytics'
import { getFeaturesForStripePlan } from 'utils/getStartedUtils'
import ToolTip from 'components/generic/ToolTip'
import {
  Price,
  Badge,
  Features,
  CheckMark,
  Star,
  FeatureHeading,
  BasicOption,
  InfoIcon,
  CouponInfo,
} from './styles'
import { AppContext } from 'contexts/AppContext'

const StepSelectPlan = ({ data, onStepComplete, userInput }) => {
  const [selectedPlan, setSelectedPlan] = useState(userInput?.stripePlan ?? null)
  const hasBasicPlan = data?.viewer?.site?.basic_plan_available
  const hasCoupon = Boolean(selectedPlan?.stripeCoupon)
  const plans = data?.viewer?.stripe_plans?.edges ?? []
  const features = selectedPlan ? getFeaturesForStripePlan(selectedPlan) : []
  const { domain } = useContext(AppContext)
  const plansSorted = [...[], ...plans]
    .map(({ node }) => ({
      ...node,
      fullPrice: getFullPriceForPlan(node),
      salePrice: getSalePriceForPlan(node),
    }))
    .reverse()
  const onNextClick = () => {
    trackClickEvent(domain, 'get-started-next-choose-plan')
    onStepComplete({
      stripePlan: selectedPlan,
    })
  }
  const onPlanClick = (plan) => {
    const isClickedPlanSelected = plan?.stripe_plan_id === selectedPlan?.stripe_plan_id
    const value = isClickedPlanSelected ? null : plan
    setSelectedPlan(value)
  }

  return (
    <ContentContainer>
      <StepHeading>Choose a Plan</StepHeading>

      {plansSorted.map((plan) => (
        <ButtonOption
          key={plan.stripe_plan_id}
          selected={selectedPlan && plan.stripe_plan_id === selectedPlan.stripe_plan_id}
          onClick={() => onPlanClick(plan)}
        >
          {plan.salePrice && (
            <Price>
              <Badge>SALE</Badge>
              <sup>$</sup>
              {formatStripePrice(plan.salePrice)}/{plan.interval_period}
            </Price>
          )}
          <Price isOnSale={plan.salePrice !== null}>
            <sup>$</sup>
            {formatStripePrice(plan.fullPrice)}/{plan.interval_period}
          </Price>
        </ButtonOption>
      ))}
      {selectedPlan && (
        <section>
          <FeatureHeading>What’s Included:</FeatureHeading>
          <Features>
            {features.map((feature, index) => (
              <li key={index}>
                {feature.isVip ? <Star icon={faStar} /> : <CheckMark icon={faCheck} />}
                {feature.label}
                {feature.tooltip && <ToolTip>{feature.tooltip}</ToolTip>}
              </li>
            ))}
          </Features>
        </section>
      )}
      {hasBasicPlan && (
        <BasicOption type='button' onClick={() => onStepComplete({ payment_plan_id: null })}>
          Basic: Limited Messages and Calls
        </BasicOption>
      )}
      {hasCoupon && (
        <CouponInfo>
          <InfoIcon icon={faInfoCircle} />
          {selectedPlan?.stripeCoupon?.durationText}
        </CouponInfo>
      )}
      <PrimaryButton mt='1rem' disabled={!selectedPlan} onClick={onNextClick}>
        Next
      </PrimaryButton>
    </ContentContainer>
  )
}

export default StepSelectPlan
